import { render, staticRenderFns } from "./EvaluationRisques.vue?vue&type=template&id=40c2a9d1"
import script from "./EvaluationRisques.vue?vue&type=script&lang=js"
export * from "./EvaluationRisques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports